module.exports = __webpack_public_path__ + "img/PPMPprint6.f3b5773b.png";